import React__default, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/CodeInput.scss';

var _excluded = ["className", "value", "setValue", "boxWidth", "length", "autoFocus"];
/**
 * Stripe style code input field. See Stripe 2 factor auth.
 */
var CodeInput = function CodeInput(_ref) {
  var className = _ref.className,
    value = _ref.value,
    setValue = _ref.setValue,
    _ref$boxWidth = _ref.boxWidth,
    boxWidth = _ref$boxWidth === void 0 ? 37 : _ref$boxWidth,
    length = _ref.length,
    autoFocus = _ref.autoFocus,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var ref = useRef();
  var inputRef = useRef();
  var _useState = useState(false),
    focus = _useState[0],
    setFocus = _useState[1];
  var index = value.length;
  var hideInput = !(value.length < length);
  var _useState2 = useState(0),
    boxMarginHorizontal = _useState2[0],
    setBoxMarginHorizonal = _useState2[1];
  useEffect(function () {
    if (inputRef.current && autoFocus !== undefined) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  // Get margins from the number boxes
  useEffect(function () {
    if (ref.current) {
      var box = ref.current.querySelector("[data-box");
      if (box) {
        var style = window && window.getComputedStyle(box);
        setBoxMarginHorizonal(parseFloat(style.marginLeft) + parseFloat(style.marginRight));
      }
    }
  }, [ref]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: cn(styles.block, className)
  }, new Array(length).fill(0).map(function (_, i) {
    var _cn;
    var allFilled = value.length === length;
    var selected = (value.length === i || allFilled && i === length - 1) && focus;
    return /*#__PURE__*/React__default.createElement("div", {
      key: i,
      "data-box": true,
      className: cn(styles.box, (_cn = {}, _cn[styles.boxSelected] = selected, _cn)),
      style: {
        width: boxWidth + "px"
      },
      onClick: function onClick() {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    }, value[i] ? value[i] : "");
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    ref: inputRef,
    value: "",
    style: {
      left: boxWidth * index + boxMarginHorizontal * index + "px",
      width: boxWidth,
      opacity: hideInput ? 0.01 : 1
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Backspace") {
        setValue(value.slice(0, value.length - 1));
      }
    },
    onChange: function onChange(e) {
      return setValue((value + e.target.value).slice(0, length));
    }
  })));
};

export { CodeInput };
//# sourceMappingURL=index.js.map
